import withErrorFallback from "@components/ErrorBoundary/withErrorFallback";

import SupportEmail from "./SupportEmail";
import SupportEmailFallback from "./SupportEmailFallback";

export default withErrorFallback(SupportEmail, SupportEmailFallback);
